import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["participantSelect", "roleSelect", "participantList", "template"]
  
  connect() {
    console.log("Participant Selector controller connected")
  }
  
  addParticipant(event) {
    event.preventDefault()
    
    if (!this.hasParticipantSelectTarget || !this.hasRoleSelectTarget) return
    
    const participantId = this.participantSelectTarget.value
    const participantName = this.participantSelectTarget.selectedOptions[0].text
    const role = this.roleSelectTarget.value
    
    if (!participantId || !role) {
      alert('Please select both a participant and a role')
      return
    }
    
    // Check if participant already added
    if (this.isParticipantAdded(participantId)) {
      alert('This participant has already been added')
      return
    }
    
    // Add participant to list
    this.addParticipantToList(participantId, participantName, role)
    
    // Reset selects
    this.participantSelectTarget.value = ''
    this.roleSelectTarget.value = ''
  }
  
  isParticipantAdded(participantId) {
    const existingInputs = this.participantListTarget.querySelectorAll('input[name*="participant_ids"]')
    return Array.from(existingInputs).some(input => input.value === participantId)
  }
  
  addParticipantToList(participantId, participantName, role) {
    const listItem = document.createElement('div')
    listItem.className = 'participant-item d-flex justify-content-between align-items-center mb-2 p-2 border rounded'
    listItem.dataset.participantId = participantId
    
    listItem.innerHTML = `
      <div>
        <strong>${participantName}</strong>
        <span class="badge badge-info ml-2">${role}</span>
      </div>
      <button type="button" 
              class="btn btn-sm btn-danger" 
              data-action="click->rating-portal--participant-selector#removeParticipant"
              data-participant-id="${participantId}">
        <i class="fas fa-times"></i>
      </button>
      <input type="hidden" name="rating[participant_ids][]" value="${participantId}">
      <input type="hidden" name="rating[participant_roles][${participantId}]" value="${role}">
    `
    
    this.participantListTarget.appendChild(listItem)
  }
  
  removeParticipant(event) {
    const button = event.currentTarget
    const participantId = button.dataset.participantId
    const listItem = this.participantListTarget.querySelector(`[data-participant-id="${participantId}"]`)
    
    if (listItem) {
      listItem.remove()
    }
  }
}
